export const establishmentPaymentAdvancesColumns = [
  { label: 'Status', value: 'status' },
  { label: 'Fatura', value: 'bill_number' },
  { label: 'Valor Adiantado', value: 'discounted_from_bill' },
  { label: 'Data da solicitação', value: 'created_at' },
  { label: 'Recebimento em', value: 'date_to_be_paid' },
  { label: 'Ações', value: 'actions', className: 'w-1' },
];
